export default "__VITE_ASSET__Dg5Ecf1S__"